// extracted by mini-css-extract-plugin
export default {"icon":"src-components-Buttons-AddIconButton-css-module__icon--zJQ4c","btnNew":"src-components-Buttons-AddIconButton-css-module__btnNew--L5LKC"};